import { TEMPLATES } from '../Home/types'
import { STEPS, TITLE_ALIGNMENT, TITLE_POSITION, WIDGET_THUMBNAIL_DIMENSIONS, WIDGET_THUMBNAIL_SIZE, WIDGET_TYPES } from './types'

const applyTemplate = ({ values, template, setFieldValue, setStep, user, submit }) => {
  const delaySetStep = (x) => setTimeout(() => setStep(x), 1)

  if (template === TEMPLATES.OFF_SITE) {
    values.isShareCampaign = true
    setFieldValue('isShareCampaign', true)

    if (user.shopifyShopUrl) {
      values.isShoppable = true
      setFieldValue('isShoppable', true)
    } else if (user.isContentCreator) {
      values.isDownloadCampaign = true
      setFieldValue('isDownloadCampaign', true)
    } else {
      values.isShoppable = false
      setFieldValue('isShoppable', false)
    }
    return
  }

  if (template === TEMPLATES.VIDEO_PLAYER) {
    if (user.shopifyShopUrl) {
      values.isShoppable = true
      setFieldValue('isShoppable', true)
    }
    values.isShareCampaign = false
    setFieldValue('isShareCampaign', false)
    return
  }

  if (template === TEMPLATES.INLINE_CAROUSEL) {
    values.isShoppable = false
    setFieldValue('isShoppable', false)

    values.isInlineCampaign = true
    setFieldValue('isInlineCampaign', true)

    values.templatePassThrough = TEMPLATES.INLINE_CAROUSEL
    setFieldValue('templatePassThrough', TEMPLATES.INLINE_CAROUSEL)

    const widgetValues = {
      ...values.widget,
      type: WIDGET_TYPES.INLINE_CAROUSEL,
      widgetThumbnailDimensions: WIDGET_THUMBNAIL_DIMENSIONS.PORTRAIT,
      widgetMobileThumbnailDimensions: WIDGET_THUMBNAIL_DIMENSIONS.PORTRAIT,
      widgetFixedThumbnailWidth: 200,
      widgetFixedThumbnail: false,
      widgetThumbnailBorder: false,
      widgetMobileThumbnailSize: WIDGET_THUMBNAIL_SIZE.LARGE,
      desktopVideos: 3,
      widgetIsFixedCircle: false,
      widgetDesktopTitleFontSize: 18,
      widgetMobileTitleFontSize: 14,
      widgetTitleFontWeight: 700,
      id: null,
      name: null,
      widgetTitlePosition: TITLE_POSITION.BELOW
    }
    values.widget = widgetValues
    setFieldValue('widget', widgetValues)

    values.widgetId = undefined
    setFieldValue('widgetId', undefined)

    values.showInstallModal = true
    setFieldValue('showInstallModal', true)
    return
  }

  if (template === TEMPLATES.STORIES) {
    if (user.shopifyShopUrl) {
      values.isShoppable = true
      setFieldValue('isShoppable', true)
    } else if (user.isContentCreator) {
      values.isDownloadCampaign = true
      setFieldValue('isDownloadCampaign', true)
    } else {
      values.isShoppable = false
      setFieldValue('isShoppable', false)
    }

    values.templatePassThrough = TEMPLATES.STORIES
    setFieldValue('templatePassThrough', TEMPLATES.STORIES)

    const widgetValues = {
      ...values.widget,
      type: WIDGET_TYPES.STORIES,
      widgetThumbnailDimensions: WIDGET_THUMBNAIL_DIMENSIONS.CIRCLE,
      widgetMobileThumbnailDimensions: WIDGET_THUMBNAIL_DIMENSIONS.CIRCLE,
      widgetFixedThumbnailWidth: 100,
      durationDisplay: false,
      widgetFixedThumbnailHeight: 100,
      widgetFixedThumbnail: true,
      widgetThumbnailBorderSize: 4,
      widgetThumbnailBorderColor: '#4c6fff',
      widgetThumbnailBorder: true,
      widgetMobileThumbnailSize: WIDGET_THUMBNAIL_SIZE.LARGE,
      desktopVideos: 4,
      widgetTitlePosition: TITLE_POSITION.BELOW,
      widgetTitleAlignment: TITLE_ALIGNMENT.CENTER,
      widgetIsFixedCircle: true,
      widgetDesktopTitleFontSize: 14,
      widgetMobileTitleFontSize: 12,
      widgetTitleFontWeight: 500,
      id: null,
      name: null
    }
    values.widget = widgetValues
    setFieldValue('widget', widgetValues)

    values.widgetId = undefined
    setFieldValue('widgetId', undefined)

    values.showInstallModal = true
    setFieldValue('showInstallModal', true)
    return
  }

  if (template === TEMPLATES.SINGLE_EMBED) {
    values.isInlineCampaign = true
    setFieldValue('isInlineCampaign', true)

    values.templatePassThrough = TEMPLATES.SINGLE_EMBED
    setFieldValue('templatePassThrough', TEMPLATES.SINGLE_EMBED)

    const widgetValues = {
      ...values.widget,
      type: WIDGET_TYPES.SINGLE_EMBED,
      widgetAutoplay: false,
      id: null,
      name: null
    }
    values.widget = widgetValues
    setFieldValue('widget', widgetValues)

    values.widgetId = undefined
    setFieldValue('widgetId', undefined)

    values.showInstallModal = true
    setFieldValue('showInstallModal', true)
    return
  }

  if (template === TEMPLATES.GRID) {
    if (user.shopifyShopUrl) {
      values.isShoppable = true
      setFieldValue('isShoppable', true)
    } else if (user.isContentCreator) {
      values.isDownloadCampaign = true
      setFieldValue('isDownloadCampaign', true)
    } else {
      values.isShoppable = false
      setFieldValue('isShoppable', false)
    }

    values.templatePassThrough = TEMPLATES.GRID
    setFieldValue('templatePassThrough', TEMPLATES.GRID)

    values.type = WIDGET_TYPES.GRID
    setFieldValue('type', WIDGET_TYPES.GRID)

    const widgetValues = {
      ...values.widget,
      type: WIDGET_TYPES.GRID,
      widgetThumbnailDimensions: WIDGET_THUMBNAIL_DIMENSIONS.PORTRAIT,
      widgetMobileThumbnailDimensions: WIDGET_THUMBNAIL_DIMENSIONS.PORTRAIT,
      widgetFixedThumbnailWidth: 200,
      widgetFixedThumbnail: false,
      widgetThumbnailBorder: false,
      widgetMobileThumbnailSize: WIDGET_THUMBNAIL_SIZE.LARGE,
      desktopVideos: 4,
      widgetIsFixedCircle: false,
      widgetDesktopTitleFontSize: 18,
      widgetMobileTitleFontSize: 14,
      widgetTitleFontWeight: 700,
      id: null,
      name: null,
      marginX: 16,
      widgetSearchShowPopular: false
    }
    values.widget = widgetValues
    setFieldValue('widget', widgetValues)

    values.widgetId = undefined
    setFieldValue('widgetId', undefined)

    values.showInstallModal = true
    setFieldValue('showInstallModal', true)
    return
  }

  if (template === TEMPLATES.NAVIGATION) {
    values.templatePassThrough = TEMPLATES.NAVIGATION
    setFieldValue('templatePassThrough', TEMPLATES.NAVIGATION)

    values.isNavigationCampaign = true
    setFieldValue('isNavigationCampaign', true)

    values.type = WIDGET_TYPES.NAVIGATION_CAROUSEL
    setFieldValue('type', WIDGET_TYPES.NAVIGATION_CAROUSEL)

    const widgetValues = {
      ...values.widget,
      type: WIDGET_TYPES.NAVIGATION_CAROUSEL,
      widgetThumbnailDimensions: WIDGET_THUMBNAIL_DIMENSIONS.PORTRAIT,
      widgetMobileThumbnailDimensions: WIDGET_THUMBNAIL_DIMENSIONS.PORTRAIT,
      widgetFixedThumbnailWidth: 200,
      widgetFixedThumbnail: false,
      widgetThumbnailBorder: false,
      widgetMobileThumbnailSize: WIDGET_THUMBNAIL_SIZE.LARGE,
      desktopVideos: 4,
      widgetIsFixedCircle: false,
      widgetDesktopTitleFontSize: 18,
      widgetMobileTitleFontSize: 14,
      widgetTitleFontWeight: 700,
      id: null,
      name: null
    }
    values.widget = widgetValues
    setFieldValue('widget', widgetValues)

    values.widgetId = undefined
    setFieldValue('widgetId', undefined)

    values.showInstallModal = true
    setFieldValue('showInstallModal', true)
    return
  }

  if (template === TEMPLATES.SEARCH) {
    values.isDownloadCampaign = true
    setFieldValue('isDownloadCampaign', true)

    values.type = WIDGET_TYPES.SEARCH
    setFieldValue('type', WIDGET_TYPES.SEARCH)

    const widgetValues = {
      ...values.widget,
      type: WIDGET_TYPES.SEARCH,
      id: null,
      name: null
    }
    values.widget = widgetValues
    setFieldValue('widget', widgetValues)

    values.widgetId = undefined
    setFieldValue('widgetId', undefined)
    return
  }
}

export default applyTemplate
